export default __webpack_public_path__ + "static/media/include_10@2x.9d968aa3.jpg";